import React from 'react';
import LoadingSpinner from './loadingSpinner'
import ApiConnectorConfigForm from './ApiConnectorConfigForm'
import {loadAccountInfo, loadSitesInfo, loadZonesInfo} from './C18utils'
import {
  cloneConnectorConfig,
  loadStoredConnectorConfig,
  saveStoredConnectorConfig,
} from '../utils/apiConnectorUtils';

class C18ThirdPartyIntegration00 extends React.Component{
  constructor(props) {
    super(props);
    this.state={
      loaded:false,
      connectorConfig: loadStoredConnectorConfig(),
      connectorValidationErrors:{},
      connectorSaveMessage:'',
    }
    this.loadInfo()
    this.setBreadCrumbs()
  }

  setBreadCrumbs=()=>{
    if(this.props.parms){
      this.props.parms.onChange(
        {
          cmd: "breadcrumbs",
          data:
            {breadcrumbs: [
              {t:"Sites", url:"/usa/c18/sites"},
              {t:"Admin", url:`/usa/c18/admin`},
              {t:"Third Party Integration", url:`/usa/c18/admin/thirdPartyIntegration`},
            ]},
        },
      )
    }
  }

  loadInfo=async()=>{
    await loadAccountInfo()
    await loadSitesInfo()
    await loadZonesInfo()
    this.setState({loaded:true})
  }

  handleConnectorChange=(connectorConfig)=>{
    this.setState({connectorConfig, connectorSaveMessage:''})
  }

  handleConnectorValidationErrors=(connectorValidationErrors)=>{
    this.setState({connectorValidationErrors})
  }

  handleConnectorSave=(connectorConfig)=>{
    saveStoredConnectorConfig(connectorConfig)
    this.setState({
      connectorConfig: cloneConnectorConfig(connectorConfig),
      connectorSaveMessage:'Connector saved successfully.',
    })
  }

  render(){
    if(!this.state.loaded){
      return <LoadingSpinner message="Loading third party integration..." />
    }
    return(
      <div className="api-connector-page">
        <div className="api-connector-page-header">
          <h2>API Connector</h2>
          <p>Set up an external API connection in four quick steps: connection, site & zone, test, then pick the response path.</p>
        </div>
        <ApiConnectorConfigForm
          config={this.state.connectorConfig}
          onChange={this.handleConnectorChange}
          onSave={this.handleConnectorSave}
          onValidationErrors={this.handleConnectorValidationErrors}
          validationErrors={this.state.connectorValidationErrors}
          saveMessage={this.state.connectorSaveMessage}
        />
      </div>
    )
  }
}

export default C18ThirdPartyIntegration00;
